import React, { useEffect, useState } from "react";

//UI Material
import {
  Button,
  Card,
  Divider,
  Grid,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";

//Material Icons
import { Add, ArrowBackIos, Search } from "@mui/icons-material";

//Local components
import SetItemCategoryDrawer from "../Components/drawers/SetItemCategoryDrawer";
import ItemCategoryRow from "../Components/items-categories/ItemCategoryRow";

//Helpers
import { searchEngine } from "../Helpers/searchEngine";
import { fetchWithTokenJSONPost } from "../Helpers/network";
import ErrorBox from "../Components/ErrorBox";
import DataLoader from "../Components/basics/DataLoader";

export default function ItemCategories() {
  // ==========>Component States<==========
  //State for open/close drawer for set product
  const [openDrawer, setOpenDrawer] = useState(false);
  //State for search data by query
  const [searchQuery, setSearchQuery] = useState("");
  //State for select page
  const [page, setPage] = useState(0);
  //State for manage rows per page
  const [rowsPerPage, setRowsPerPage] = useState(10);
  //State for categories list
  const [categoriesList, setCategoriesList] = useState([]);
  //State for setting loader for products data
  const [dataLoader, setDataLoader] = useState(false);
  //State for setting error when could not get products data
  const [dataError, setDataError] = useState(false);

  // ==========>Component UseEffects<==========
  //The useEffect checks for token validation
  useEffect(() => {
    getCategoriesList();
  }, []);

  // ==========> Component Functions <==========
  //Function to manage page selection
  const handleChangePage = (_event, newPage) => {
    setPage(newPage);
  };
  //Function to control rows per page options
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  //Function for data query
  const filterData = (query, data) => {
    if (!query) {
      return data;
    } else {
      return searchEngine(data, query);
    }
  };

  //Data in the table
  const dataFiltered = filterData(searchQuery, categoriesList);

  //Function to get products list
  const getCategoriesList = async () => {
    setDataLoader(true);
    try {
      const requestResponse = await fetchWithTokenJSONPost(
        `/inventory/get-categories`,
        {
          howMany: 1000,
        }
      );
      const jsonResponse = await requestResponse.json();
      if (requestResponse.status === 200) {
        setCategoriesList(jsonResponse.data);
      } else {
        if (requestResponse.status === 401) {
          window.location.href = "/";
        }
      }
    } catch (error) {
      setDataError(true);
    }
    setDataLoader(false);
  };

  if (dataLoader) {
    return <DataLoader />;
  }

  return dataError ? (
    <ErrorBox />
  ) : (
    <Grid container spacing={1}>
      <SetItemCategoryDrawer
        open={openDrawer}
        setOpen={setOpenDrawer}
        getData={getCategoriesList}
      />
      <Grid item xs={12}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          spacing={1}
        >
          <Button
            startIcon={<ArrowBackIos />}
            color="secondary"
            sx={{ color: "white" }}
            variant="contained"
            size="small"
            onClick={() => {
              window.history.back();
            }}
          >
            Volver
          </Button>
          <Button
            variant="contained"
            color="secondary"
            size="small"
            sx={{ color: "white" }}
            endIcon={<Add />}
            onClick={() => {
              setOpenDrawer(true);
            }}
          >
            nueva categoría
          </Button>
        </Stack>
      </Grid>
      <Grid item xs={12}>
        <Card raised>
          <Grid container>
            <Grid item xs={12} sx={{ p: 2 }}>
              <Typography variant="h6" fontWeight="bold">
                Registro de categorías de ítems
              </Typography>
            </Grid>
            <Grid item xs={12} sx={{ p: 2 }}>
              <Stack spacing={1} sx={{ width: "100%" }}>
                <Typography variant="body2" fontWeight="bold">
                  Buscar una categoría
                </Typography>
                <TextField
                  id="search-bar"
                  onChange={(e) => {
                    setSearchQuery(e.target.value);
                  }}
                  variant="outlined"
                  placeholder="Buscar..."
                  fullWidth
                  InputProps={{
                    endAdornment: <Search />,
                  }}
                />
              </Stack>
            </Grid>
            <Grid item xs={12}>
              <Divider />
            </Grid>
            <Grid item xs={12}>
              <TableContainer>
                <Table aria-label="products-table">
                  <TableHead>
                    <TableRow>
                    <TableCell align="center">
                        <Typography variant="body2" fontWeight="bold">
                          ID
                        </Typography>
                      </TableCell>
                      <TableCell align="center">
                        <Typography variant="body2" fontWeight="bold">
                          Nombre
                        </Typography>
                      </TableCell>
                      <TableCell align="center">
                        <Typography variant="body2" fontWeight="bold">
                          Descripcióm
                        </Typography>
                      </TableCell>
                      <TableCell align="center">
                        <Typography variant="body2" fontWeight="bold">
                          Identificador de ítems
                        </Typography>
                      </TableCell>
                      <TableCell align="center">
                        <Typography variant="body2" fontWeight="bold">
                          Cantidad de ítems
                        </Typography>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {dataFiltered.length ? (
                      dataFiltered
                        .sort((a, b) => {
                          if (a.name < b.name) return -1;
                          if (a.name > b.name) return 1;
                          return 0;
                        })

                        .map((product) => (
                          <ItemCategoryRow
                            key={`${product.id}-${product.createdAt}`}
                            category={product}
                            getCategories={() => {
                              getCategoriesList();
                            }}
                          />
                        ))
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                    ) : (
                      <TableRow>
                        <TableCell align="center" colSpan={6}>
                          <Typography variant="body2" fontWeight="bold">
                            No hay categorías registradas
                          </Typography>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                component="div"
                count={dataFiltered.length}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                labelRowsPerPage="Filas"
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Grid>
          </Grid>
        </Card>
      </Grid>
    </Grid>
  );
}
